import { render, staticRenderFns } from "./InvoiceTableData.vue?vue&type=template&id=74468f98&scoped=true&"
import script from "./InvoiceTableData.vue?vue&type=script&lang=js&"
export * from "./InvoiceTableData.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTableData.vue?vue&type=style&index=0&id=74468f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74468f98",
  null
  
)

export default component.exports